import React from "react";
import { useStore } from "../../context/store.provider";

function VerifayAdmin({ children }) {
  const { isAuth } = useStore();

  const secureComponent = () => {
    const auth = isAuth;
    if (auth) {
      return children[0];
    } else {
      return children[1];
    }
  };

  return <>
             {secureComponent()}
        </>;
}

export default VerifayAdmin;
